<template>
  <div
    class="showcase"
    :data-theme="theme"
    data-cont="small"
  >
    <BasePicture
      class="showcase__item"
      v-for="(picture, index) in data.list"
      :key="index"
      :data="Object.assign(picture, { tagImg: false })"
    />
    <div
      class="showcase__item u-hidden--until-mobileL"
      v-if="data.list.length % 3 !== 0"
    ></div>
    <div class="ui-container--button" v-if="data.url">
      <BaseButtonFilled :data="Object.assign(data, { routerLink: data.url.startsWith('/') })" />
    </div>
  </div>
</template>

<script>
import BasePicture from '@/components/BasePicture.vue';
import BaseButtonFilled from '@/components/BaseButtonFilled.vue';
import { mapGetters } from 'vuex';


export default {
  name: 'showcase',

  components: {
    BasePicture,
    BaseButtonFilled,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['getRouteName', 'getCity']),
    theme() {
      if (this.getCity === 'new-york' && this.data.backgroundText === 'Workshops') return 'blue';
      if (this.getRouteName === 'home' && this.data.backgroundText === 'Workshops') return 'azure';
      if (this.getRouteName === 'adobe-meetup') return 'pink';
      return 'yellow';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/utils";

.showcase {
  position: relative;
  width: 100%;
  margin: 80px auto 0;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;

  &[data-theme="pink"] {
    margin: 0 auto 80px;
  }

  &__item {
    position: relative;
    flex: 0 0 100%;
    width: 100%;
    margin-top: 100px;

    @include aspect-ratio(4, 5);

    &:first-child {
      margin-top: 0;
    }

    @include mq(mobileL) {
      flex: 0 0 30%;
      width: 30%;
      margin-top: 0;
    }
  }

  .ui-container--button {
    position: relative;
    width: 100%;
    flex: 0 0 100%;
    padding-top: 40px;

    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    @include mq(mobileL) {
      padding-top: 80px;
      justify-content: flex-end;
    }
  }
}
</style>
